/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { EnMetricDistrict } from './en-metric-district';
import { EnMetricMovement } from './en-metric-movement';
import { EnMetricSide } from './en-metric-side';
import { JoinEntityDto } from './join-entity-dto';
 /**
 *
 *
 * @export
 * @interface RomTargetDto
 */
export interface RomTargetDto {

    /**
     * Unique identifier
     *
     * @type {number}
     * @memberof RomTargetDto
     * @example 1
     */
    id: number;

    /**
     * Creation timestamp (ISO 8601)
     *
     * @type {string}
     * @memberof RomTargetDto
     * @example 2024-01-15T10:30:00.000Z
     */
    created: string;

    /**
     * Last update timestamp (ISO 8601)
     *
     * @type {string}
     * @memberof RomTargetDto
     * @example 2024-06-01T08:00:00.000Z
     */
    updated: string;

    /**
     * Soft-delete timestamp — null when the record is active
     *
     * @type {string}
     * @memberof RomTargetDto
     */
    deleted: string | null;

    /**
     * @type {EnMetricDistrict}
     * @memberof RomTargetDto
     */
    district: EnMetricDistrict;

    /**
     * @type {EnMetricSide}
     * @memberof RomTargetDto
     */
    side: EnMetricSide;

    /**
     * @type {EnMetricMovement}
     * @memberof RomTargetDto
     */
    movement: EnMetricMovement;

    /**
     * @type {number}
     * @memberof RomTargetDto
     */
    goalDegrees: number;

    /**
     * @type {JoinEntityDto}
     * @memberof RomTargetDto
     */
    user: JoinEntityDto;
}
